import colorCompare from './color-compare';
import { formatCancelTranslateImage } from '../store/app/setObject';
import store from '@/store';
import { sendLog } from '@/utils/sentry';
import { message } from 'ant-design-vue';
import { getDefaultFont } from '@/constants';
import { uniq } from 'lodash-es';

const isMacSafari = () => {
  const userAgent = navigator.userAgent.toLocaleLowerCase();
  return userAgent.indexOf('mac os') > -1 && userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1;
};

// 精修链接中的字符黑名单，都会被替换掉
const fixUrlCharacterBlackList = /[【】]/g;

export const getFixedFileName = (OriginUrl, withFixed = true) => {
  const suffix = withFixed ? '_fixed' : '';
  try {
    let nameArr = (OriginUrl.split('/').reverse()[0] || '').split('.');
    // 把后缀去掉，剩下的部分再通过.连起来
    // e.g. 1.5X1.8米（组合B）_b672cd2ca7d47c36_f48e15ce0bf4d702.jpg
    // ↓    1.5X1.8米（组合B）_b672cd2ca7d47c36_f48e15ce0bf4d702
    nameArr.length > 1 && nameArr.pop();
    const name = nameArr.join('.').replace(fixUrlCharacterBlackList, '');
    return (name || +new Date()) + suffix;
  } catch (err) {
    return +new Date() + suffix;
  }
};

export const parseJSON = (str, fallback) => {
  let result = fallback;
  try {
    result = JSON.parse(str);
  } catch (err) {}
  return result;
};

// 中日韩方块字
export const isJCKLanguage = lang => {
  return ['JPN', 'CHS', 'CHT', 'KOR'].indexOf(lang) > -1;
};

// 格式化从接口返回的数据
export const normalizeObjectPropsFromRemote = origin => {
  if (!origin) return;
  const {
    bounding_box,
    ori_bounding_box = '[]',
    font_size,
    line_count,
    source,
    target,
    orientation,
    background_color = 'transparent',
    fg = '0,0,0',
    bg, // shadow
    align,
    textAlign,
    lineHeight = 1,
    fontFamily = getDefaultFont(origin.TargetLanguage),
    TargetLanguage,
  } = origin;
  console.log('11111111', TargetLanguage, fontFamily);

  const isJCK = isJCKLanguage(TargetLanguage);
  // 非方块字
  const isABC = !isJCK;

  const boundingBox = parseJSON(bounding_box, []);
  let width = boundingBox[1][0] - boundingBox[0][0];
  let height = boundingBox[3][1] - boundingBox[0][1];
  let left = boundingBox[0][0];
  let top = boundingBox[0][1];

  // origin的宽高左右用于取消翻译时还原图片的位置
  let originWidth = width;
  let originHeight = height;
  let originLeft = left;
  let originTop = top;
  try {
    const oringinBoundingBox = parseJSON(ori_bounding_box, []);
    originWidth = oringinBoundingBox[1][0] - oringinBoundingBox[0][0];
    originHeight = oringinBoundingBox[3][1] - oringinBoundingBox[0][1];
    originLeft = oringinBoundingBox[0][0];
    originTop = oringinBoundingBox[0][1];
  } catch (err) {}

  // 计算旋转角度
  const vDiff = boundingBox[1][1] - boundingBox[0][1];
  let angle = 0;
  // 非水平&非垂直的情况
  if (vDiff !== 0) {
    const hDiff = boundingBox[1][0] - boundingBox[0][0];
    angle = (Math.atan(vDiff / hDiff) * 180) / Math.PI;
    angle = Math.abs(angle) <= 3 ? 0 : angle;
  }

  // 垂直且不是方块字
  if (orientation === 'v' && isABC) {
    const temp = width;
    width = height;
    height = temp;
    // 垂直
    if (vDiff === 0) {
      angle = 90;
      left = left + height / 2;
    }
    // 倾斜
    else {
      // 试出来的，尝试下斜向下，斜向上，且他们的不同的角度（大于45，小于45都试试）
      angle = angle < 0 ? 90 + angle : angle - 90;
      // 倾斜的文字与垂直方向形成了一个直角三角形，已知斜边width/2、角度angle，求该角度的对边的长度
      // left = left + (width / 2) * Math.sin(angle);
      // 直接left加宽度一半得了
      left = left + width / 2;
      console.log(999999999, angle, origin);
    }
  }

  angle = Math.ceil(angle);

  let fontSize = 1.05 * Math.ceil(parseFloat(font_size, 10) * 1);
  // fontSize = orientation === 'v' ? Math.ceil(fontSize * 0.8) : fontSize;
  const result = {
    fontSize,
    source,
    fg: `rgb(${fg})`,
    target,
    orientation,
    backgroundColor: background_color,
    width,
    height,
    left,
    top,
    angle,
    textAlign: textAlign || align || 'left',
    lineHeight,
    fontFamily,
    TargetLanguage,
    lineCount: line_count,
    paintFirst: 'stroke',
    originWidth,
    originHeight,
    originLeft,
    originTop,
  };

  // console.log(111111, result);
  // 几乎每个文本都带有bg，需要判断bg与fg是否相似，来决定是否显示阴影
  // 同时，如果bg与fg相似，则将其设置为透明，blur设置为0，表示没有阴影
  if (bg) {
    const strokeInfo = getStroke({ bg: `rgb(${bg})`, fg: result.fg, fontSize });
    if (strokeInfo) {
      Object.assign(result, strokeInfo);
    } else {
      result.strokeWidth = 0;
      result.stroke = 'transparent';
    }
  } else {
    result.strokeWidth = 0;
    result.stroke = 'transparent';
  }

  return result;
};

// 将fabric object上的属性转换成属性编辑器支持的格式
export const normalizeObjectProps4PropsEditor = (newObjectProps = {}, oldObject) => {
  const { fontStyle, fontWeight, fill, ...rest } = newObjectProps;
  const result = rest;
  if (fill) {
    result.fg = fill;
  }

  result.fontStyle = [
    !fontWeight || fontWeight === -1 ? oldObject.fontWeight : fontWeight,
    !fontStyle || fontStyle === -1 ? oldObject.fontStyle : fontStyle,
  ];
  console.log({ oldObject, newObjectProps, result });

  return result;
};

export const getGradientColor = options => {
  try {
    return options.fgType === 'gradient'
      ? new fabric.Gradient({
          type: 'linear',
          coords:
            options.fgGradientDirection === 'h'
              ? { x1: 0, y1: 0, x2: options.width, y2: 0 }
              : { x1: 0, y1: 0, x2: 0, y2: options.height },
          colorStops: [
            { offset: 0, color: options.fgGradientStart },
            { offset: 1, color: options.fgGradientEnd },
          ],
        })
      : '';
  } catch (err) {
    return '';
  }
};

export const transformEditorProps4canvas = (propsFromEditor = {}) => {
  const { fontStyle, fg, lineHeight, backgroundColor, ...rest } = propsFromEditor;
  const result = rest;
  if (Array.isArray(fontStyle)) {
    if (fontStyle[0] !== -1) {
      result.fontWeight = fontStyle[0];
    }
    if (fontStyle[1] !== -1) {
      result.fontStyle = fontStyle[1];
    }
  }
  if (lineHeight) {
    result.lineHeight = lineHeight;
  }
  if (fg) {
    result.fill = fg;
  }
  if (backgroundColor && backgroundColor !== -1) {
    result.backgroundColor = backgroundColor;
  }

  return result;
};

// 格式化从属性编辑器返回的数据格式
// 属性编辑器中返回的数据格式与canvas渲染object要求的数据格式不尽相同
export const normalizeObjectPropsFromPropsEditor = origin => {
  if (!origin) return;
  if (origin.type === 'rect') {
    return origin;
  }
  if (origin.type === 'image' && origin.$$isCancelTranslated) {
    return formatCancelTranslateImage(origin);
  }
  // key不同的或者需要设置默认值的被单独提出来，其他的一致的放在rest里
  const {
    fontStyle = [],
    textAlign = 'left',
    target = '',
    fg,
    source,
    orientation,
    fontFamily = '',
    backgroundColor = 'transparent',
    angle = 0,
    bg,
    fontSize,
    shadowBlur,
    fgType,
    fgGradientDirection,
    fgGradientStart,
    fgGradientEnd,
    ...rest
  } = origin;

  const isJCK = isJCKLanguage(rest.TargetLanguage);
  const gradient = getGradientColor({
    fgType,
    fgGradientDirection,
    fgGradientStart,
    fgGradientEnd,
    width: origin.width,
    height: origin.height,
  });

  const result = {
    ...rest,
    text: target,
    textAlign,
    // fg,
    // gradient,
    fill: fgType === 'pure' ? fg : gradient,
    fontFamily,
    backgroundColor,
    angle,
    fontSize,
    orientation,
    fontWeight: fontStyle.indexOf('bold') > -1 ? 'bold' : 'normal',
    fontStyle: fontStyle.indexOf('italic') > -1 ? 'italic' : 'normal',
    // 英文根据空格进行wrap，中/日文需要设置splitByGrapheme为true
    // 否则不会按照width换行，而是会撑大width
    splitByGrapheme: isJCK,
    // selectionBackgroundColor: '#2154f4',
  };

  if (!result.fontFamily && isMacSafari()) {
    // result.fontFamily = 'SYHT';
  }

  // 属性发生变化后判断是否有阴影设置
  const shadow = getShadow({ bg, fg, shadowBlur, fontSize });
  if (shadow) {
    result.shadow = new fabric.Shadow(shadow);
  } else {
    result.shadow = null;
  }
  console.log(888888888, '----', result);
  return result;
};

function getWidthByFontSize(fontSize) {
  return Math.ceil(Math.max(fontSize * 0.07, 1));
}
function getRGBValue(rgba) {
  try {
    return rgba.match(/\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/).slice(1, 4);
  } catch (err) {
    return [];
  }
}
// 通过判断文字颜色与阴影色是否相近，来得到是否显示描边
export function getStroke({ strokeWidth, fontSize, fg, bg }) {
  if (strokeWidth === 0) return null;
  const fgRGB = getRGBValue(fg);
  const bgRGB = getRGBValue(bg);
  const diff = colorCompare(fgRGB, bgRGB);
  const stroke = diff < 10 ? null : bg;
  const offset = strokeWidth || getWidthByFontSize(fontSize);
  if (stroke) {
    return {
      stroke,
      strokeWidth: offset,
    };
  } else {
    return null;
  }
}
// 通过判断文字颜色与阴影色是否相近，来得到是否显示shadow
export function getShadow({ shadowBlur, fontSize, fg, bg }) {
  if (shadowBlur === 0) return null;
  const fgRGB = getRGBValue(fg);
  const bgRGB = getRGBValue(bg);
  const diff = colorCompare(fgRGB, bgRGB);
  const color = diff < 10 ? null : bg;
  const offset = shadowBlur || getWidthByFontSize(fontSize);
  // console.log(222222, diff, fgRGB, bgRGB, color, offset, bg);
  if (color) {
    return {
      color,
      offsetX: 0,
      offsetY: 0,
      blur: offset,
    };
  } else {
    return null;
  }
}

export const formatterPx = value => {
  if (+value === -1) return '...';
  const v = parseInt(value, 10);
  return isNaN(v) ? 0 : v + 'px';
};

export const batchFormatPx = obj => {
  return Object.keys(obj).reduce((map, key) => {
    map[key] = formatterPx(obj[key]);
    return map;
  }, {});
};

export const parsePx = value => {
  if (value === '...') return -1;
  value = value.replace('px', '');
  const v = parseInt(value, 10);
  return isNaN(v) ? 0 : v;
};

export const findTopText = map => {
  return Object.keys(map)
    .map(uid => ({ ...map[uid], uid }))
    .filter(i => i.type !== 'path' && i.type !== 'rect' && i.type !== 'image')
    .sort((a, b) => (a.top > b.top ? 1 : -1));
};

export const getGroupingObjects = () => {
  const objects = $XJCanvas.getObjects().filter(i => i.group);
  return {
    group: objects[0]?.group,
    objects,
  };
};

// 获取转存过的url，用于解决外链跨域问题
export const getCORSImageUrl = (url = '') => {
  try {
    if (url.indexOf('data:image/') === 0) return url;
    const { hostname = '' } = new URL(url) || {};
    // myhuaweicloud是我们的华为obs地址
    const isOur = ['tosoiot.com', 'myhuaweicloud.com'].some(i => hostname.indexOf(i) > -1);
    return isOur ? url : `https://www.tosoiot.com/img-trans/show-img?url=${url}`;
  } catch (err) {
    return url;
  }
};

export const activeElementNotInputable = () => {
  const { tagName } = document.activeElement;
  return tagName !== 'INPUT' && tagName !== 'TEXTAREA';
};

// 水印会影响图片整体的颜色（盖了一层遮罩），屏幕取色的时候就会有问题，所以在下载和保存之前这个时机添加水印，结束之后立马移除
export const addWatermark = (WatermarkLayerUrl, enable, callback) => {
  if (WatermarkLayerUrl && enable) {
    $XJCanvas.setOverlayImage(
      WatermarkLayerUrl,
      (img, isError) => {
        sendLog(`addWatermark_${isError ? 'fail' : 'success'}`);
        $XJCanvas.renderAll();
        callback();
      },
      {
        originX: 'left',
        originY: 'top',
        crossOrigin: 'anonymous',
      }
    );
  } else {
    callback();
  }
};

export const removeWatermark = () => {
  $XJCanvas.overlayImage = null;
  $XJCanvas.renderAll();
};

export const obj2query = obj => {
  const arr = Object.keys(obj).reduce((arr, key) => {
    arr.push(`${key}=${encodeURIComponent(obj[key])}`);
    return arr;
  }, []);

  return arr.join('&');
};

export const hash2obj = () => {
  const { hash } = location;
  // 提取 hash 部分
  const hashIndex = hash.indexOf('#/?');
  if (hashIndex === -1) return {};

  const hashString = hash.slice(hashIndex + 3); // 去掉 `#/?`
  // 分割并解析为键值对
  return hashString.split('&').reduce((acc, pair) => {
    const [key, value] = pair.split('=');
    acc[decodeURIComponent(key)] = value ? decodeURIComponent(value) : null;
    return acc;
  }, {});
};

export const getObjectByUid = uid => {
  return $XJCanvas.getObjects().filter(i => i.$$uid === uid)[0];
};

export const scroll2object = object => {
  if (!object) return;
  try {
    const scrollEl = document.querySelector('#main-editor');
    const canvas = document.querySelector('#xj-canvas');
    const canvasTop = canvas.getBoundingClientRect().top;
    const canvasLeft = canvas.getBoundingClientRect().left;
    const winWidth = window.innerWidth - 80 - 280;
    const winHeight = window.innerHeight;
    const { canvasScale } = store.state.app;
    const threshold = 30;
    let { top, height, width, left } = object;
    top = top * canvasScale;
    left = left * canvasScale;
    width = width * canvasScale;
    height = height * canvasScale;
    const bottom = top + height;
    const right = left + width;
    console.log('top', top + canvasTop + threshold >= winHeight, bottom + canvasTop - threshold <= 0);
    if (top + canvasTop + threshold >= winHeight || bottom + canvasTop - threshold <= 0) {
      scrollEl.scrollTop = top;
    }
    console.log('left', left + canvasLeft + threshold >= winWidth, right + canvasLeft - threshold <= 0);
    if (left + canvasLeft + threshold >= winWidth || right + canvasLeft - threshold <= 0) {
      scrollEl.scrollLeft = left;
    }
  } catch (err) {}
};

export const rgb2hex = color => {
  if (color.substr(0, 1) === '#' || color === 'transparent') {
    return color;
  }

  /**
   * strip spaces
   */
  var strippedColor = color.replace(/\s+/g, '');

  /**
   * parse input
   */
  var digits = /(.*?)rgb(a)??\((\d{1,3}),(\d{1,3}),(\d{1,3})(,([01]|1.0*|0??\.([0-9]{0,})))??\)/.exec(strippedColor);

  if (!digits) {
    // or throw error if input isn't a valid rgb(a) color
    // throw new Error('given color (' + color + ") isn't a valid rgb or rgba color");
    return color;
  }

  var red = parseInt(digits[3], 10);
  var green = parseInt(digits[4], 10);
  var blue = parseInt(digits[5], 10);
  var alpha = digits[6] ? /([0-9\.]+)/.exec(digits[6])[0] : '1';
  var rgb = (blue | (green << 8) | (red << 16) | (1 << 24)).toString(16).slice(1);

  // parse alpha value into float
  if (alpha.substr(0, 1) === '.') {
    alpha = parseFloat('0' + alpha);
  }

  // cut alpha value after 2 digits after comma
  alpha = parseFloat(Math.round(alpha * 100)) / 100;

  return '#' + rgb.toString(16);
};

// 复制文本到剪切板
export const copyText = text => {
  let textarea = document.createElement('textarea'); //创建input对象
  let currentFocus = document.activeElement; //当前获得焦点的元素
  let toolBoxwrap = document.getElementById('app'); //将文本框插入到NewsToolBox这个之后
  toolBoxwrap.appendChild(textarea); //添加元素
  textarea.value = text;
  textarea.focus();
  if (textarea.setSelectionRange) {
    textarea.setSelectionRange(0, textarea.value.length); //获取光标起始位置到结束位置
  } else {
    textarea.select();
  }
  try {
    var flag = document.execCommand('copy'); //执行复制
    console.log('copy success');
    message.success('复制成功');
  } catch (eo) {
    var flag = false;
  }
  toolBoxwrap.removeChild(textarea); //删除元素
  currentFocus.focus();
  return flag;
};

export const setCompressParam = (url, param) => {
  if (!url) return url;
  if (url.indexOf('data:') === 0) {
    return url;
  } else {
    return `${url}${url.indexOf('?') > -1 ? '&' : '?'}${param}`;
  }
};

export const getCroppedImage = (img, cropInfo) => {
  const { width, height, left, top } = cropInfo;
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  // console.log(img, cropInfo, canvas);
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, left, top, width, height, 0, 0, width, height);
  const result = canvas.toDataURL();
  // console.log(result);
  return result;
};

export const loadFonts = (fonts = []) => {
  fonts = uniq(fonts);
  console.log('fonts', fonts);
  if (fonts.length === 0) return Promise.resolve();
  try {
    return Promise.all(
      fonts.map(name => {
        const obs = new window.FontFaceObserver(name);
        return obs.load();
      })
    )
      .then(fonts => {
        console.log('fonts loaded', fonts);
      })
      .catch(err => {
        console.log('fonts load error', err);
      });
  } catch (err) {
    return Promise.resolve(err);
  }
};

export const createMappingTable = (list, keyField = 'value') => {
  return list.reduce((map, item) => {
    map[item[keyField]] = item;
    return map;
  }, {});
};

export const addFontFace = (fonts = [], fontMap = {}) => {
  fonts = uniq(fonts);
  console.log('fonts', fonts);
  if (fonts.length === 0) return Promise.resolve();
  return Promise.all(
    fonts.map(font => {
      const { fontUrl } = fontMap[font] || {};
      if (!fontUrl) return Promise.resolve();
      const customFont = new FontFace(font, `url(${fontUrl})`);
      return customFont.load().then(function (loaded_face) {
        document.fonts.add(loaded_face);
        console.log('font loaded', font);
      });
    })
  );
};

export const preloadFont = async (fonts = [], customFontMap) => {
  console.log('preloadFont', fonts);
  const systemFonts = fonts.filter(i => i?.startsWith('ff-'));
  const customFonts = fonts.filter(i => i?.startsWith('custom-'));
  return await Promise.all([loadFonts(systemFonts), addFontFace(customFonts, customFontMap || {})]);
};

export const uppercaseByWords = (input = '') => {
  try {
    const block = '\\w\\u0400-\\u04FF';
    const reg = new RegExp('([^' + block + ']|^)([' + block + '])', 'g');
    return input.toLowerCase().replace(reg, ($0, $1, $2) => {
      return $1 + $2.toUpperCase();
    });
  } catch (err) {
    return input;
  }
};

export const uppercaseBySentence = (input = '') => {
  try {
    const splitter = '.。;；';
    const reg = new RegExp('([^' + splitter + ']+|^)([' + splitter + ']|$)', 'g');
    return input.toLowerCase().replace(reg, ($0, $1, $2) => {
      const sentence = $1.toLowerCase();
      console.log({ sentence, $2 });
      return sentence.replace(/([^\s]+)/, ($0, $1) => $1.charAt(0).toUpperCase() + $1.slice(1)) + $2;
    });
  } catch (err) {
    return input;
  }
};

/**
 * 检测指定的url是否存在
 * @param {*} url 需要检测的url
 * @returns true：存在；false：不存在或检查失败
 */
export const checkUrlExist = url => {
  return new Promise((res, rej) => {
    // todo华为云偶尔会出现跨域，默认存在
    if (!url) {
      res(false);
      return false;
    }
    try {
      const img = new Image();
      img.onload = () => {
        console.log('[checkUrlExist]自定义logo加载成功', url);
        res(true);
      };
      img.onerror = () => {
        console.log('[checkUrlExist]自定义logo加载失败', url);
        res(false);
      };
      img.src = url;
    } catch (e) {
      console.log('[checkUrlExist]logo检查失败', url, e);
    }
  });
};

export const getHashValue = key => {
  try {
    const hash = location.hash.replace('#/?', '');
    const map = hash
      .split('&')
      .map(i => i.split('='))
      .reduce((map, item) => {
        map[item[0]] = item[1];
        return map;
      }, {});
    return map[key];
  } catch (err) {
    return undefined;
  }
};

// 每次记录到历史记录中的状态
export const getRecordState = state => {
  return {
    objectPropsMap: state.objectPropsMap,
    objectUIDs: state.objectUIDs,
    RmUrl: state.RmUrl,
    OriginUrl: state.OriginUrl,
    cropInfo: state.cropInfo,
  };
};

export const isBase64 = str => {
  return /^data:image\/(png|jpeg|jpg|gif|bmp|webp);base64,/.test(str);
};
